import DashboardLayout from 'components/DashboardLayout';
import ModalServicesMrh from 'components/ModalServices/ModalServicesMrh';
import NotificationsBloc from 'components/NotificationsBloc';
import Faq from 'containers/AUTODashboard/Body/FrequentlyAskedQuestions';
import { StyledShortBody } from 'containers/AUTODashboard/Body/FrequentlyAskedQuestions/styles';
import WelcomeHeader from 'containers/AUTODashboard/Header/WelcomeHeader';
import ActionButtons from 'containers/MRhDashboard/actionButtons';
import DeclareSinistre from 'containers/MRhDashboard/DeclareSinistre';
import MyContracts from 'containers/MRhDashboard/MyContracts';
import Services from 'containers/MRhDashboard/services';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
import GaLoadHOC from 'helpers/GATracking/GaLoadHOC';
import HeaderMRH from 'images/header-mrh.png';
import { sanlamDarkBlue } from 'Material-UI/colors';
import React, { useEffect } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { connect, useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getContractsMrh } from 'store/contract/actions';
import { getContractsMrhSelector } from 'store/contract/selectors';
import {
  getFaq,
  getLastNotification,
  openModalServicesMrh,
  setMrhDetailsPageBreadcrumbsPath,
  setNotificationRead,
} from 'store/global/actions';
import {
  getIsModalServicesMrhSelector,
  getLastNotificationMRHSelector,
  getMrhFaqSelector,
} from 'store/global/selectors';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import { getFirstNameSelector } from 'store/user/selectors';
import { PRIVILEGES } from 'utils/globalConst';

const MRHDashboard = ({
  getLastNotification,
  lastNotificationMRH,
  setNotificationRead,
  getContractsMrh,
  contractsMrh,
  ...props
}: {
  intl: IntlShape;
  firstName: string;
  setMrhDetailsPageBreadcrumbsPath: Function;
  openModalServicesMrh: Function;
  getLastNotification: Function;
  setNotificationRead: Function;
  lastNotificationMRH: {
    type: string;
    id: Number;
    idApp: string;
    action_title: string;
    message: string;
    title: string;
    policyNumber: string;
    status: string;
    read: boolean;
  };
  getContractsMrh: Function;
  contractsMrh: {
    status: string;
    adresse: string;
    deadline: string;
    product: string;
    contractNumber: string;
  }[];
  isOpenModalServiceMrh: boolean;
  getFaq: Function;
  faqMrh: [];
}) => {
  const language = useSelector(getLocaleSelector);
  const { MRH } = PRIVILEGES;

  useEffect(() => {
    getLastNotification(MRH);
  }, [MRH, getLastNotification]);
  /* eslint-disable */
  useEffect(() => {
    getContractsMrh();
  }, [getContractsMrh]);
  /* eslint-enable */
  useEffect(() => {
    props.getFaq(language);
    // eslint-disable-next-line
  }, [language]);
  return (
    <GaLoadHOC
      category={EVENT_CATEGORIES.MRH_ACCUEIL}
      label="Header MRH_BOUTON  MRH"
    >
      <>
        <DashboardLayout
          MyContracts={<MyContracts contractsMRH={contractsMrh} />}
          Faq={
            <Faq
              items={
                props.faqMrh &&
                props.faqMrh.map(
                  (
                    item: { question: string; code: string; id: number },
                    index: number,
                  ) => ({
                    title: (
                      <StyledShortBody
                        weight="bold"
                        color={sanlamDarkBlue}
                        key={index}
                      >
                        {item.question}
                      </StyledShortBody>
                    ),
                    path: '/faq',
                    id: item.id,
                    code: item.code,
                    isFaq: true,
                    category: EVENT_CATEGORIES.MRH_ACCUEIL,
                    label: 'FAQ_' + ++index,
                  }),
                )
              }
              GACategoryAllResponses={EVENT_CATEGORIES.MRH_ACCUEIL}
            />
          }
          LastSinistre={
            <DeclareSinistre
              openModalServicesMrh={props.openModalServicesMrh}
            />
          }
          WelcomeHeader={<WelcomeHeader name={props.firstName} />}
          HeaderImage={HeaderMRH}
          ServicesBloc={<Services position={6} />}
          NotificationsBloc={
            <NotificationsBloc
              message={
                lastNotificationMRH?.message && lastNotificationMRH.message
              }
              ignoreNotify={() =>
                setNotificationRead({
                  id: lastNotificationMRH.id,
                  section: MRH,
                  isRedirectTo: false,
                })
              }
              clickEvent={() =>
                setNotificationRead({
                  id: lastNotificationMRH.id,
                  section: MRH,
                })
              }
            />
          }
          MenuItem={
            <ActionButtons
              setDetailsPageBreadcrumbsPath={
                props.setMrhDetailsPageBreadcrumbsPath
              }
              openModalServicesMrh={props.openModalServicesMrh}
            />
          }
        />

        <ModalServicesMrh isOpen={props.isOpenModalServiceMrh} />
      </>
    </GaLoadHOC>
  );
};

const mapDispatchToProps = {
  setMrhDetailsPageBreadcrumbsPath,
  getLastNotification,
  getContractsMrh,
  setNotificationRead,
  openModalServicesMrh,
  getFaq,
};

const mapStateToProps = createStructuredSelector<
  any,
  {
    lastNotificationMRH: {
      type: string;
      id: Number;
      idApp: string;
      action_title: string;
      message: string;
      title: string;
      policyNumber: string;
      status: string;
      read: boolean;
    };
    contractsMrh: any;
    firstName: string;
    isOpenModalServiceMrh: boolean;
    faqMrh: [];
  }
>({
  firstName: getFirstNameSelector,
  lastNotificationMRH: getLastNotificationMRHSelector,
  contractsMrh: getContractsMrhSelector,
  isOpenModalServiceMrh: getIsModalServicesMrhSelector,
  faqMrh: getMrhFaqSelector,
});
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(MRHDashboard));
export { MRHDashboard };
